import { render, staticRenderFns } from "./MonitorsTable.vue?vue&type=template&id=62c6832d&scoped=true"
import script from "./MonitorsTable.vue?vue&type=script&lang=ts"
export * from "./MonitorsTable.vue?vue&type=script&lang=ts"
import style0 from "./MonitorsTable.vue?vue&type=style&index=0&id=62c6832d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6832d",
  null
  
)

export default component.exports